import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email';
import Phone from './Phone';
import Appointment from './Appointment';
import DropDown from './DropDown';
import LongText from './LongText';
import FileUpload from './FileUpload';

const GoogleIssuesReportForm = () => {


    const typeIssueData = [
        'مشکلات ورود به سیستم',
        'امنیت حساب',
        'صورتحساب و پرداخت‌ها',
        'اشکالات محصول',
        'مشکلات عملکرد',
        'دیگر',
    ]

    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم گزارش مشکلات گوگل'} subHeader={'لطفاً از این فرم برای گزارش هرگونه مشکل یا ایرادی که با سرویس‌ها یا محصولات گوگل دارید استفاده کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام کامل شما'} />
                <Email header={'آدرس ایمیل شما'}/>
                <Phone header={'شماره تلفن شما'}/>
                <Appointment header={'تاریخ و زمان وقوع مشکل'}/>
                <DropDown header={'نوع مشکل'} options={typeIssueData}/>
                <LongText header={'مسئله را با جزئیات شرح دهید'}/>
                <FileUpload header={'آپلود اسکرین‌شات‌ها یا فایل‌های خطا'}/>
            </Grid>
        </Grid>
    )
}

export default GoogleIssuesReportForm
